// extracted by mini-css-extract-plugin
export var header = "Header-module--header--1Qt4T";
export var header_fixColor = "Header-module--header_fixColor--2DIcF";
export var header__menuLogo = "Header-module--header__menuLogo--1Rs-V";
export var header__menu = "Header-module--header__menu--1E_B4";
export var header__menuLogo_invert = "Header-module--header__menuLogo_invert--wR3GL";
export var header__menuLogo_link = "Header-module--header__menuLogo_link--PKDoV";
export var header__menuRecord = "Header-module--header__menuRecord--JWYOX";
export var header__menuRecord_show = "Header-module--header__menuRecord_show--1rgXf";
export var header__buttonContent = "Header-module--header__buttonContent--1fIER";
export var header__buttonDescription = "Header-module--header__buttonDescription--3ZuZl";
export var header__imageTg = "Header-module--header__imageTg--3QtzS";
export var header__link = "Header-module--header__link--_XaZ9";